import React from "react";
import { ICommonIconProps } from "../interface";

const YoutubeIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "35"}
      height={props?.IconHeight || "30"}
      viewBox="0 0 39 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5114 19.198V7.80196L25.7045 13.5003L15.5114 19.198ZM38.185 4.21614C37.7365 2.55651 36.4149 1.24962 34.737 0.806082C31.6957 0 19.5 0 19.5 0C19.5 0 7.30437 0 4.26294 0.806082C2.58499 1.24962 1.26341 2.55651 0.814951 4.21614C0 7.22409 0 13.5 0 13.5C0 13.5 0 19.7758 0.814951 22.7839C1.26341 24.4435 2.58499 25.7504 4.26294 26.1941C7.30437 27 19.5 27 19.5 27C19.5 27 31.6957 27 34.737 26.1941C36.4149 25.7504 37.7365 24.4435 38.185 22.7839C39 19.7758 39 13.5 39 13.5C39 13.5 39 7.22409 38.185 4.21614Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default YoutubeIcon;
